module.exports = __webpack_public_path__ + "img/coal-master-wide-dark-600.94e3a449.png";